//export default    一个的时候
//export function f() {}   多个扩展的时候
import axios from "axios";

// export function request(config,success,failure) {
//     //1创建实例
//     const instance =axios.create({
//         baseURL:'http://192.168.1.91:8001/',
//         timeout:5000
//     })
//     //发送网络请求
//     instance(config)
//         .then(res => {
//             //console.log(res);
//             success(res)
//         })
//         .catch(res => {
//             //console.log(err);
//             failure(err)
//         })
// }
// export function request(config) {
//     //1创建实例
//     return new Promise((resolve,reject) => {
//         const instance=axios.create({
//         baseURL:'http://123.207.32.32:8000',
//         timeout:5000
//     })
//     //发送网络请求
//     instance(config)
//         .then(res => {
//             //console.log(res);
//             resolve(res)
//         })
//         .catch(err => {
//             //console.log(err);
//             reject(err)
//         })
// })}

export function request(config) {
    //创建实例    baseURL:'http://www.rnaphasep.cn/',
    const instance=axios.create({
        baseURL:'http://www.rnaphasep.cn/',
        timeout:5000
    })
    //拦截器
    instance.interceptors.request.use(config =>{
        // console.log(config);
        return config
    },err => {
        console.log(err);
    });
    instance.interceptors.response.use(res => {
        // console.log(res);
        return res.data
    }, err => {
        console.log(err);
    })
    //发送网络请求
    return  instance(config)
}